<section class="section-index">
	<ng-container *ngIf="!currentUser">
		<div class="container-fluid band p-3">
			<div class="container px-3">
				<div class="row" *ngIf="!currentUser">
					<div class="col-12 col-md-6 text-center">
						<img [src]="introImage" class="img-fluid" alt="{{systemTitle}} ⋆ {{systemSlogan}}" />
					</div>
					<div class="col-12 col-md-5 my-5 my-sm-0 mt-sm-5 d-flex">
						<div class="d-flex align-items-center">
							<div class="d-block">
								<div class="text-white">
									<h2 class="section-title">{{sectionIntro}}</h2>
								</div>
								<p class="mt-3"><a href="{{salesWebsite}}" title="Lees meer over {{systemTitle}}"
										class="btn  btn-info">Meer informatie voor docenten</a></p>
							</div>
						</div>
					</div>
				</div>
				<div class="row" *ngIf="currentUser" [innerHTML]="introText"></div>
			</div>
		</div>
	</ng-container>
	<ng-container *ngIf="currentUser">
		<div *ngIf="banner != null" class="container-fluid band p-3" [style.backgroundColor]="banner.color">
			<div class="container px-3">
				<div class="row">
					<div class="col-12 col-md-6 text-center">
						<img *ngIf="banner.image && !banner.youtube" class="img-fluid"
							alt="Afbeelding banner.title"
							[src]="banner.image">

						<iframe style="aspect-ratio: 16 / 9; width: 100%;" *ngIf="banner.youtube" type="text/html"
							[src]="embed(banner.youtube)" frameborder="0"></iframe>
					</div>
					<div class="col-12 col-md-5 my-5 my-sm-0 d-flex">
						<div class="d-flex align-items-center">
							<div class="d-block">
								<div class="text-white">
									<div class="section-title">
										<h2 [innerHTML]="banner.title"></h2>
										<p [innerHTML]="banner.body"></p>
									</div>
								</div>
								<p class="mt-3"><a *ngIf="banner.buttonText" (mouseenter)="hoverButton($event, true)" (mouseleave)="hoverButton($event, false)" class="btn" [style.color]="banner.buttonTextColor" [style.backgroundColor]="banner.buttonBackgroundColor" [href]="banner.link">{{banner.buttonText}}</a></p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div *ngIf="banner == null" class="container-fluid band p-3">
			<div class="container px-3">
				<div class="row" *ngIf="!currentUser">
					<div class="col-12 col-md-6 text-center">
						<img [src]="introImage" class="img-fluid" alt="{{systemTitle}} ⋆ {{systemSlogan}}" />
					</div>
					<div class="col-12 col-md-5 my-5 my-sm-0 mt-sm-5 d-flex">
						<div class="d-flex align-items-center">
							<div class="d-block">
								<div class="text-white">
									<h2 class="section-title">{{sectionIntro}}</h2>
								</div>
								<p class="mt-3"><a href="{{salesWebsite}}" title="Lees meer over {{systemTitle}}"
										class="btn  btn-info">Meer informatie voor docenten</a></p>
							</div>
						</div>
					</div>
				</div>
				<div class="row" *ngIf="currentUser" [innerHTML]="introText"></div>
			</div>
		</div>
	</ng-container>

	<section class="container-fluid main sections grayBG section-index-chapters" *ngIf="frontType != 'CHAPTER'">

		<div class="container py-5">
			<section class="no-modules-container" *ngIf="topSectionsIsLoaded && topSections.length == 0">
				<div class="alert alert-warning" *ngIf="currentUser && currentUser['role'] == 'STUDENT'">Deze klas heeft
					nog
					geen modules toegewezen gekregen. Roep je docent er even bij!</div>
				<div class="alert alert-warning" *ngIf="currentUser && currentUser['role'] != 'STUDENT'">Er zijn op dit
					moment geen actieve licenties voor deze school. Als je nog niet hebt besteld, <a
						href="https://uitgeverijneo.nl/contact">neem
						dan contact met ons op</a>.</div>
			</section>

			<div>
				<div>
					<h2 class="mb-4 blue">Keuzevakken</h2>
					<div class="row row-cols-1 row-cols-sm-2 row-cols-lg-3">

						<ng-container *ngFor="let elective of electives">
							<div class="col mb-5" [ngClass]="{
								'no-license': !activeChapterIds.includes(elective.id) && checkLicense == true
							}">
								<h3 class="card-title">{{elective.slug}}</h3>
								<div class="card" routerLink="/elective/{{elective.id}}">
									<img src="{{elective.image}}" class="card-img-top" alt="{{elective.slug}}">
									<div class="card-body p-4">
										<p class="card-text">{{elective.name}}</p>
									</div>
								</div>
							</div>
						</ng-container>

					</div>

				</div>
			</div>

		</div>
	</section>

	<div class="main">
		<div class="container">
			<h2 class="mb-4 mt-5 yellow">Uitgelicht</h2>
		</div>
		<div class="container-fluid band carouselBG keuzeopdrachten p-3" *ngIf="frontType != 'CHAPTER'">
			<div class="container carouselContainer px-3">
				<ngb-carousel [pauseOnHover]="true" [showNavigationArrows]="false" [showNavigationIndicators]="true">
					<ng-template ngbSlide *ngFor="let _ of [].constructor(getCarouselSize()); index as i">
						<div *ngFor="let card of splitCarouselAtIndex(i)" class="carouselCard" [ngStyle]="{'background-image': 'url(' + card.image + ')'}">
							<a href="/les/{{card['id']}}" class="carouselCard__link">
								<div class="mt-auto m-4">
									<p class="card-text stretched-link px-3">{{card.name}} <i class="fas fa-caret-right"></i></p>
								</div>
							</a>
						</div>
					</ng-template>
				</ngb-carousel>
			</div>
		</div>
	</div>

	<section class="container-fluid main sections section-index-extra extra" *ngIf="frontType != 'CHAPTER'">

		<div class="container py-5">
			<section class="no-modules-container" *ngIf="topSectionsIsLoaded && topSections.length == 0">
				<div class="alert alert-warning" *ngIf="currentUser && currentUser['role'] == 'STUDENT'">Deze klas heeft
					nog geen modules toegewezen gekregen. Roep je docent er even bij!</div>
				<div class="alert alert-warning" *ngIf="currentUser && currentUser['role'] != 'STUDENT'">Er zijn op dit
					moment geen actieve licenties voor deze school. Als je wel hebt besteld, <a
						href="https://uitgeverijneo.nl/contact">neem dan contact met ons op.</a></div>
			</section>

			<h2 class="mb-4 red" *ngIf="bottomExtra[0] != undefined">{{bottomExtra[0]['name']}}</h2>
			<div class="row row-cols-1 row-cols-sm-2 row-cols-lg-3">
				<ng-container *ngFor="let section of bottomExtra">
					<ng-container *ngFor="let chapter of section['chapters']">
						<div class="col mb-5">
							<h3 class="card-title">{{chapter.slug}}</h3>
							<div class="card" routerLink="/module/{{chapter.slug}}">
								<img src="{{chapter.image}}" class="card-img-top" alt="{{chapter.slug}}">
								<div class="card-body p-4">
									<!-- <ng-container *ngFor="let chapter of section['chapters']">

									</ng-container> -->
								</div>
							</div>
						</div>
					</ng-container>
				</ng-container>
			</div>
		</div>
	</section>

	<div class="container py-5" *ngIf="frontTypeChapter && frontType == 'CHAPTER'">
		<div class="row">
			<ng-container *ngFor="let lesson of frontTypeChapter['lessons']">
				<div class="mb-4 col-md-6" [ngClass]="{
					'col-xl-4': frontTypeChapter['style'] == '3_COLUMN',
					'col-xl-6': frontTypeChapter['style'] != '3_COLUMN'
				}">
					<div class="card">
						<img src="{{lesson['image']}}" class="card-img-top" alt="{{lesson['name']}}" />
						<div class="card-body p-5">
							<h3 class="card-title" style="font-size: 150%;">{{lesson['name']}}</h3>
							<p class="card-text" [innerHTML]="text(lesson['description'])">
							</p>
						</div>
						<div class="mt-auto m-5">
							<a href="/module/{{lesson['name']}}" class="btn btn-card stretched-link px-3"
								title="Ga naar deze les">
								Ga naar deze les <i class="fas fa-caret-right"></i>
							</a>
						</div>
					</div>
				</div>
			</ng-container>
		</div>
	</div>

	<!-- @TODO omzetten naar notificatie -->
	<section class="last-lesson-alert-container p-4" *ngIf="currentUser && !currentUser['lastLessonId']">
		<h3>Welkom bij {{systemTitle}}!</h3>
	</section>
</section>